import { createAction, handleActions } from 'redux-actions';

import { List, Map, fromJS } from 'immutable';
import { pender } from 'redux-pender';
import axios from 'axios';

import * as examLib from 'libs/examLib';
import * as normalizer from 'libs/normalizer';

// action types
const INITIAL_STORE = 'examSummary/INITIAL_STORE';
const CHANGE_EXAM_SUMMARY = 'examSummary/CHANGE_EXAM_SUMMARY';
const CHANGE_PARAM = 'examSummary/CHANGE_PARAM';
const TOGGLE_OPEN = 'examSummary/TOGGLE_OPEN';
const GET_EXAM_SUMMARY = 'examSummary/GET_EXAM_SUMMARY';
const PUT_EXAM_RESEND = 'examSummary/PUT_EXAM_RESEND';
const PUT_EXAM_SUMMARY = 'examSummary/PUT_EXAM_SUMMARY';
const DELETE_EXAM_SUMMARY = 'examSummary/DELETE_EXAM_SUMMARY';
const EXAM_PAUSE = 'examSummary/EXAM_PAUSE';

// action creator
export const initialStore = createAction(INITIAL_STORE);
export const changeExamSummary = createAction(CHANGE_EXAM_SUMMARY);
export const changeParam = createAction(CHANGE_PARAM);
export const toggleisOpen = createAction(TOGGLE_OPEN);
export const getExamSummary = createAction(GET_EXAM_SUMMARY, examLib.getExam);
export const putExamResend = createAction(PUT_EXAM_RESEND, examLib.putExamResend);
export const putExam = createAction(PUT_EXAM_SUMMARY, examLib.putExam);
export const deleteExam = createAction(DELETE_EXAM_SUMMARY, examLib.deleteExam);
export const examPause = createAction(EXAM_PAUSE, examLib.postExamPause);

const initialState = Map({
  isMounting: false,
  needReload: false,
  examSummaryOrdering: List([]),
  examSummaryByExamNo: Map({}),
  param: Map({
    filter: Map({}),
    sort: [{ field: 'examNo', order: 'DESC' }],
    offset: 0,
    limit: 15
  }),
  // page: 1,
  // totalPage: 0
});

export default handleActions(
  {
    // store 초기화
    [INITIAL_STORE]: (state, action) => {
      return initialState;
    },
    [CHANGE_EXAM_SUMMARY]: (state, action) => {
      const { name, value } = action.payload;

      return state.set(name, value);
    },
    [CHANGE_PARAM]: (state, action) => {
      const { name, value } = action.payload;

      return state.setIn(['param', name], value);
    },
    // 훈련 목록 조회
    ...pender({
      type: GET_EXAM_SUMMARY,
      onSuccess: (state, action) => {
        if (typeof action.payload === 'undefined') {
          return state;
        }

        const { list } = action.payload.data;
        // const { refresh, offset, limit } = action.payload.config.params;

        state = state.set('needReload', false);
        state = state.set('isMounting', false);

        // let curPage = 1;
        // let curArray = [];
        // let curData = {};

        // // 전체 목록 수
        // const totalCount = list.length > 0 ? list[0].rnum + offset : 0;
        // // 전체 페이지 수
        // const totalPages = Math.ceil(totalCount / limit);

        // if (list.length > 0) {
        //   // 새로고침
        //   if (refresh) {
        //     state = state.set('totalPage', totalPages);

        //     curArray = normalizer.examArrayNormalize(list);
        //     curData = normalizer.examNormalize(list);
        //     // 무한스크롤 요청
        //   } else {
        //     curPage = state.get('page') + 1;

        //     curArray = state
        //       .get('examSummaryOrdering')
        //       .toJS()
        //       .concat(normalizer.examArrayNormalize(list));
        //     curData = Object.assign(state.get('examSummaryByExamNo').toJS(), normalizer.examNormalize(list));
        //   }
        // }

        // return state
        // .set('page', curPage)
        //   .set('examSummaryOrdering', fromJS(curArray))
        //   .set('examSummaryByExamNo', fromJS(curData));

        return state
          .set('examSummaryOrdering', fromJS(normalizer.examArrayNormalize(list)))
          .set('examSummaryByExamNo', fromJS(normalizer.examNormalize(list)));
      },
      onFailure: (state, action) => {
        return state.set('examSummaryOrdering', List([])).set('examSummaryByExamNo', Map({}));
      }
    }),
    // 훈련메일 재전송
    ...pender({
      type: PUT_EXAM_RESEND,
      onSuccess: (state, action) => {
        return state;
      },
      onFailure: (state, action) => {
        return state.set('examSummaryOrdering', List([])).set('examSummaryByExamNo', Map({}));
      }
    }),
    // 훈련 목록 수정
    ...pender({
      type: PUT_EXAM_SUMMARY,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;
        const typeList = Object.keys(JSON.parse(action.payload.config.data));

        for (let i = 0, l = typeList.length; i < l; i++) {
          // 훈련 즉시 시작
          if (typeList[i] === 'isStartNow') {
            state = state.setIn(
              ['examSummaryByExamNo', String(list[0].examNo), 'examStartEpoch'],
              list[0]['examStartEpoch']
            );
            // 훈련 즉시 종료
          } else if (typeList[i] === 'isEndNow') {
            state = state.setIn(
              ['examSummaryByExamNo', String(list[0].examNo), 'examEndEpoch'],
              list[0]['examEndEpoch']
            );
          } else if (typeList[i] !== 'examNo') {
            //
            state = state.setIn(['examSummaryByExamNo', String(list[0].examNo), typeList[i]], list[0][typeList[i]]);
          }
        }

        return state;
      },
      onFailure: (state, action) => {
        return state.set('examSummaryOrdering', List([])).set('examSummaryByExamNo', Map({}));
      }
    }),
    // 훈련 목록 삭제
    ...pender({
      type: DELETE_EXAM_SUMMARY,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;

        for (let i = 0, l = list.length; i < l; i++) {
          const index = state.getIn(['examSummaryOrdering']).findIndex(examNo => examNo === list[i].examNo);

          state = state
            .setIn(['examSummaryOrdering'], state.getIn(['examSummaryOrdering']).delete(index))
            .set('examSummaryByExamNo', state.get('examSummaryByExamNo').delete(String(list[i].examNo)));
        }

        return state;
      },
      onFailure: (state, action) => {
        return state.set('examSummaryOrdering', List([])).set('examSummaryByExamNo', Map({}));
      }
    }),
    // 메일 발송 일시정지, 재시작
    ...pender({
      type: EXAM_PAUSE,
      onSuccess: (state, action) => {
        const { list } = action.payload.data;

        state = state.setIn(['examSummaryByExamNo', String(list[0].examNo), 'isSuspend'], list[0]['isSuspend']);

        return state;
      },
      onFailure: (state, action) => {
        return state.set('examSummaryOrdering', List([])).set('examSummaryByExamNo', Map({}));
      }
    }),
    [TOGGLE_OPEN]: (state, action) => {
      const index = state.findIndex(exam => exam.get('id') === action.payload);

      return state.update(index, exam => exam.set('isOpen', !exam.get('isOpen')));
    }
  },
  initialState
);



// WEBPACK FOOTER //
// ./src/script/modules/examSummary.js